import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getInsidePpt, getSonData, getMapDepotType } from '@/views/schemeManage/data';
export default {
  name: 'ReferenceStyleGalleryDialog',
  inject: {
    elForm: {
      default: null
    }
  },
  props: {
    formData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      referenceStyleDialogVisible: false,
      referenceStyleSearchForm: {
        pagesize: 16,
        page: 1,
        name: ''
      },
      referenceStyleTypeList: [],
      referenceStyleParentTypeList: [],
      referenceStyleParentTypeId: '',
      referenceStyleGalleryList: [],
      referenceStylePages: {
        currentPage: 1,
        totalCount: 0
      },
      referenceStyleSelectedItems: [],
      referenceStyleSonTypeId: 'all',
      referenceStylePreviewVisible: false,
      referenceStylePreviewUrl: ''
    };
  },
  methods: {
    open: function open() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.referenceStyleDialogVisible = true;
              _this.referenceStyleSearchForm.page = 1;
              _this.referenceStyleSearchForm.name = '';
              _this.referenceStyleSonTypeId = 'all';
              _this.referenceStyleSelectedItems = [];
              _context.n = 1;
              return _this.getReferenceStyleParentTypeList();
            case 1:
              _context.n = 2;
              return _this.getReferenceStyleTypeList();
            case 2:
              _context.n = 3;
              return _this.getReferenceStyleGalleryList();
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getReferenceStyleTypeId: function getReferenceStyleTypeId() {
      return process.env.VUE_APP_NAME === 'production' ? 46 : 427;
    },
    getReferenceStyleParentTypeList: function getReferenceStyleParentTypeList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, list;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return getMapDepotType({
                type_id: 46
              });
            case 1:
              res = _context2.v;
              list = res.data || [];
              _this2.referenceStyleParentTypeList = Array.isArray(list) ? list : [];
              if (_this2.referenceStyleParentTypeList.length) {
                _this2.referenceStyleParentTypeId = _this2.referenceStyleParentTypeList[0].id;
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    handleReferenceStyleParentTypeChange: function handleReferenceStyleParentTypeChange() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.referenceStyleSearchForm.page = 1;
              _context3.n = 1;
              return _this3.getReferenceStyleTypeList();
            case 1:
              _context3.n = 2;
              return _this3.getReferenceStyleGalleryList();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getReferenceStyleTypeList: function getReferenceStyleTypeList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _res$data;
        var res, list;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return getSonData({
                type_id: _this4.referenceStyleParentTypeId || _this4.getReferenceStyleTypeId(),
                is_all: 0
              });
            case 1:
              res = _context4.v;
              list = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.list) || [];
              _this4.referenceStyleTypeList = [{
                name: '全部',
                id: 'all'
              }].concat(_toConsumableArray(list.map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  id: String(item.id)
                });
              })));
              // 二级分类默认选中全部（'all' 代表全部，请求时转为空串）
              _this4.referenceStyleSonTypeId = 'all';
              return _context4.a(2, list.length > 0);
          }
        }, _callee4);
      }))();
    },
    getReferenceStyleGalleryList: function getReferenceStyleGalleryList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!(_this5.referenceStyleTypeList.length <= 1)) {
                _context5.n = 1;
                break;
              }
              _this5.referenceStyleGalleryList = [];
              _this5.referenceStylePages = {
                currentPage: 1,
                totalCount: 0
              };
              return _context5.a(2);
            case 1:
              _context5.n = 2;
              return getInsidePpt(_objectSpread(_objectSpread({}, _this5.referenceStyleSearchForm), {}, {
                type_id: _this5.referenceStyleSonTypeId === 'all' ? _this5.referenceStyleParentTypeId || _this5.getReferenceStyleTypeId() : _this5.referenceStyleSonTypeId,
                son_type_id: _this5.referenceStyleSonTypeId === 'all' ? '' : _this5.referenceStyleSonTypeId
              }));
            case 2:
              res = _context5.v;
              _this5.referenceStyleGalleryList = res.data || [];
              _this5.referenceStylePages = res.pages || {
                currentPage: 1,
                totalCount: 0
              };
            case 3:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    searchReferenceStyleGallery: function searchReferenceStyleGallery() {
      this.referenceStyleSearchForm.page = 1;
      this.getReferenceStyleGalleryList();
    },
    changeReferenceStyleGalleryPage: function changeReferenceStyleGalleryPage(page) {
      this.referenceStyleSearchForm.page = page;
      this.getReferenceStyleGalleryList();
    },
    previewReferenceStyleImage: function previewReferenceStyleImage(url) {
      this.referenceStylePreviewUrl = url;
      this.referenceStylePreviewVisible = true;
    },
    isReferenceStyleSelected: function isReferenceStyleSelected(item) {
      return this.referenceStyleSelectedItems.some(function (selectedItem) {
        return selectedItem.id === item.id;
      });
    },
    toggleReferenceStyleSelection: function toggleReferenceStyleSelection(item) {
      var selectedIndex = this.referenceStyleSelectedItems.findIndex(function (selectedItem) {
        return selectedItem.id === item.id;
      });
      if (selectedIndex > -1) {
        this.referenceStyleSelectedItems.splice(selectedIndex, 1);
        return;
      }
      var referStyle = this.formData.items.card_and_coupon_design.refer_style;
      if (referStyle.some(function (style) {
        return style.url === item.image;
      })) {
        this.$message.warning('该图片已选择');
        return;
      }
      if (referStyle.length + this.referenceStyleSelectedItems.length >= 4) {
        this.$message.warning('最多支持上传/选择4张图片');
        return;
      }
      this.referenceStyleSelectedItems.push(item);
    },
    confirmReferenceStyleGallery: function confirmReferenceStyleGallery() {
      if (!this.referenceStyleSelectedItems.length) {
        this.$message.error('请选择图片');
        return;
      }
      var referStyle = this.formData.items.card_and_coupon_design.refer_style;
      if (referStyle.length >= 4) {
        this.$message.warning('最多支持上传/选择4张图片');
        return;
      }
      var unselectedItems = this.referenceStyleSelectedItems.filter(function (item) {
        return !referStyle.some(function (style) {
          return style.url === item.image;
        });
      });
      if (!unselectedItems.length) {
        this.$message.warning('该图片已选择');
        return;
      }
      var availableCount = 4 - referStyle.length;
      referStyle.push.apply(referStyle, _toConsumableArray(unselectedItems.slice(0, availableCount).map(function (item) {
        return {
          file_name: item.name || '',
          url: item.image
        };
      })));
      if (unselectedItems.length > availableCount) {
        this.$message.warning('最多支持上传/选择4张图片');
      }
      this.referenceStyleDialogVisible = false;
      this.elForm && this.elForm.validateField('items.card_and_coupon_design.refer_style');
    }
  }
};